import { createSelector } from 'reselect';
import { AppState } from '../types/store';
import { TimePeriod } from '../types/reports';

export const getSlice = (state: AppState) => state.studio?.reports;

export const getSoldProducts = createSelector(
  [getSlice],
  reports => reports?.soldProducts
);

export const getSoldSubscriptions = createSelector(
  [getSlice],
  reports => reports?.soldSubscriptions
);

export const getTopSellingProducts = createSelector(
  [getSlice],
  reports => reports?.topSellingProducts
);

export const getTopCustomers = createSelector(
  [getSlice],
  reports => reports?.topCustomers
);

export const getSoldExclusives = createSelector(
  [getSlice],
  reports => reports?.soldExclusives
);

export const getTopSubscribers = createSelector(
  [getSlice],
  reports => reports?.topSubscribers
);

export const getSubsCancellationReasons = createSelector(
  [getSlice],
  reports => reports?.subsCancellationReasons
);

export const getHasAnyReportsData = createSelector([getSlice], reports => {
  if (!reports) {
    return false;
  }
  for (const data of Object.values(reports)) {
    if (data?.timePeriods?.[TimePeriod.ALL]?.length) {
      return true;
    }
  }
  return false;
});
